import React from 'react';
import Widget from 'components/ui/layout/panel/Widget';
import Icon from 'components/ui/element/Icon';

const NotAuthorizedTemplate = ({formatMessage}) => (
    <div className="no-authorized-template no-modal">
        <Widget>
            <h1>{formatMessage({id: 'title.serviceNotFound.service'}, {service: 'Backup'})}</h1>
            <p>{formatMessage({id: 'notAuthorized.backups.description'})}</p>
            <ul>
                <li><b>{formatMessage({id: 'notAuthorized.backups.option1.name'})}</b> {formatMessage({id: 'notAuthorized.backups.option1.description'})}</li>
                <li><b>{formatMessage({id: 'notAuthorized.backups.option2.name'})}</b> {formatMessage({id: 'notAuthorized.backups.option2.description'})}</li>
                <li><b>{formatMessage({id: 'notAuthorized.backups.option3.name'})}</b> {formatMessage({id: 'notAuthorized.backups.option3.description'})}</li>
            </ul>
            <p>{formatMessage({id: 'notAuthorized.backups.feature.title'})}</p>
            <ul>
                <li>{formatMessage({id: 'notAuthorized.backups.feature.option1'})}</li>
                <li>{formatMessage({id: 'notAuthorized.backups.feature.option2'})}</li>
                <li>{formatMessage({id: 'notAuthorized.backups.feature.option3'})}</li>
                <li><b>{formatMessage({id: 'notAuthorized.backups.feature.option4.name'})}</b> {formatMessage({id: 'notAuthorized.backups.feature.option4.description'})}</li>
                <li><b>{formatMessage({id: 'notAuthorized.backups.feature.option5.name'})}</b> {formatMessage({id: 'notAuthorized.backups.feature.option5.description'})}</li>
            </ul>
        </Widget>
        <Widget className="no-authorized-template__contact">
            <h1><Icon key={'envelope'} name={'envelope'} /> {formatMessage({id: 'label.contacts.contact'})}</h1>
            <p>{formatMessage({id: 'notAuthorized.contact'})}</p>
            <ul>
                <li><a href="mailto:Solutions.EMS.Spain@eu.equinix.com">Solutions.EMS.Spain@eu.equinix.com</a></li>
            </ul>
        </Widget>
    </div>
);

module.exports = NotAuthorizedTemplate;



// WEBPACK FOOTER //
// ./src/routes/no-authorized-templates/backups.js